var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 405 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 1,
    transform: "matrix(-1 0 0 1 180 17)",
    fill: "white",
    className: "svg-elem-1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.0662,
    height: 1.25171,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 189.936 26.9512)",
    fill: "white",
    className: "svg-elem-2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.168,
    y: 26.9453,
    width: 13,
    height: 1.25171,
    transform: "rotate(-45 188.168 26.9453)",
    fill: "white",
    className: "svg-elem-3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 1,
    transform: "matrix(-1 0 0 1 183 20)",
    fill: "url(#paint0_linear_146_1348)",
    className: "svg-elem-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 17,
    width: 180,
    height: 1,
    fill: "white",
    className: "svg-elem-5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.064,
    y: 26.9512,
    width: 14.0662,
    height: 1.25171,
    transform: "rotate(-45 215.064 26.9512)",
    fill: "white",
    className: "svg-elem-6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 1.25171,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 216.832 26.9453)",
    fill: "white",
    className: "svg-elem-7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 20,
    width: 171,
    height: 1,
    fill: "url(#paint1_linear_146_1348)",
    className: "svg-elem-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 11.6562,
    width: 8,
    height: 8,
    transform: "rotate(-45 197 11.6562)",
    fill: "#AC9FFF",
    className: "svg-elem-9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 11.6074,
    width: 15,
    height: 15,
    transform: "rotate(-45 192 11.6074)",
    stroke: "white",
    className: "svg-elem-10"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_146_1348",
    x1: 1,
    y1: 0.999771,
    x2: 86.5,
    y2: 1.49985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_146_1348",
    x1: 223,
    y1: 20.9998,
    x2: 308.5,
    y2: 21.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleDecoration);
export default __webpack_public_path__ + "static/media/titleDecoration.70604d045c395ff6eaec69e3ec166ee5.svg";
export { ForwardRef as ReactComponent };